import React from 'react'
import { Path } from 'react-native-svg'

import { createIcon } from '../../_gluestack/icon'

export const SeasonalTaskIcon = createIcon({
    viewBox: '0 0 24 24',
    path: (
        <>
            <Path
                d='M17.688 3.22965C18.8078 3.18486 19.7744 4.00586 19.912 5.11809C20.826 12.5093 14.6963 18.8557 7.28637 18.2106L6.65163 20.7557C6.56826 21.0892 6.22997 21.2925 5.8965 21.2093C5.56301 21.1259 5.35972 20.7876 5.44293 20.4541L6.32088 16.9448C6.9963 14.2431 8.5574 11.845 10.7556 10.1353L13.1365 8.28452C13.4079 8.0736 13.7985 8.12261 14.0096 8.39396C14.2205 8.66537 14.1715 9.05599 13.9001 9.26704L11.5205 11.119C9.61417 12.6018 8.24149 14.6592 7.6001 16.9825C14.1287 17.4252 19.4846 11.8073 18.6766 5.2713C18.6185 4.80184 18.2105 4.45475 17.7378 4.47361L13.6728 4.63655C8.90007 4.82746 5.32289 8.9858 5.75105 13.6588C5.78242 14.0012 5.55579 14.3227 5.21657 14.3791C4.8775 14.4355 4.55468 14.206 4.51998 13.864C3.97075 8.45071 8.10109 3.61225 13.6229 3.39138L17.688 3.22965Z'
                fill='currentColor'
            />
        </>
    ),
})

SeasonalTaskIcon.displayName = 'SeasonalTaskIcon'
